import axios from '../../config/axios.js'
import store from '../../vuex/store.js'

const STATE = {

    payment: {},
    request_online_url: null,
    request_mobile_url: null,
    request_order_no: null,
    request_check_status: null,
    update_online_url: null,
    update_mobile_url: null,
    update_order_no: null,
    update_check_status: null,

}

const GETTERS = {

    payment: state => state.payment,
    request_online_url: state => state.request_online_url,
    request_mobile_url: state => state.request_mobile_url,
    request_order_no: state => state.request_order_no,
    request_check_status: state => state.request_check_status,
    update_online_url: state => state.update_online_url,
    update_mobile_url: state => state.update_mobile_url,
    update_order_no: state => state.update_order_no,
    update_check_status: state => state.update_check_status,

}

const MUTATIONS = {

    getPayment(state, payment) {
        state.payment = payment
    },

    setRequestOnlineURL(state, online_url) {
        state.request_online_url = online_url
    },

    setRequestMobileURL(state, mobile_url) {
      state.request_mobile_url = mobile_url
    },

    setRequestOrderNo(state, order_no) {
        state.request_order_no = order_no
    },

    setUpdateOnlineURL(state, online_url) {
      state.update_online_url = online_url
    },

    setUpdateMobileURL(state, mobile_url) {
      state.update_mobile_url = mobile_url
    },

    setUpdateOrderNo(state, order_no) {
      state.update_order_no = order_no
    },

    setRequestCheckStatus(state, check_status) {
        state.request_check_status = check_status
    },

    setUpdateCheckStatus(state, check_status) {
        state.update_check_status = check_status
    },

}

const ACTIONS = {

    async startTrial({ commit }, payload) {
        await axios.CONFIRM.post('/api/payment', {
                kind: 2,
                product: payload.product,
            })
            .then(res => {
                // console.log('/payment/startTrial', res)
                if (res.data.result) {
                    store.commit('auth/setAccessToken', res.data.access_token)
                    store.commit('auth/storeAccessToken', res.data.access_token)
                    commit('getPayment', res.data.payment)
                } else { throw new Error(res.data) }
            })
    },

    async payWithCash({ commit }, payload) {
        await axios.CONFIRM.post('/api/payment', {
                kind: 1,
                product: payload.prod_id,
            })
            .then(res => {
                // console.log('/payment/payWithCash', res)
                if (!res.data.result) {
                    throw new Error(res.data)
                } else {
                    commit('getPayment', res.data.payment)
                }
            })
    },

    async requestPayletter({ commit }, payload) {
        await axios.CONFIRM.post('/api/payletter/request', {
                product: payload.product,
                pgcode: payload.pgcode,
            })
            .then(res => {
                // console.log('payletter/request', res)
                if (!res.data.result) {
                    throw new Error()
                } else {
                    commit('setRequestOnlineURL', res.data.online_url)
                    commit('setRequestMobileURL', res.data.mobile_url)
                    commit('setRequestOrderNo', res.data.order_no)
                }
            })
    },

    async returnRequestPayletter({ commit }, payload) {
      await axios.ACCESS.post('/api/payletter/request/return', {
        order_no: payload.order_no
      })
      .then(res => {
        // console.log('payletter/request/return', res)
        if (!res.data.result) {
          throw new Error()
        }
      })
    },

    async checkRequestPayletter({ commit }, payload) {
        await axios.CONFIRM.get('/api/payletter/request/return/' + payload.order_no)
            .then(res => {
                // console.log('payletter/request/check', res)
                if (!res.data.result) {
                    throw new Error()
                } else {
                    commit('setRequestCheckStatus', res.data.status)
                    if (res.data.status == 7) {
                        store.commit('auth/setAccessToken', res.data.access_token)
                        store.commit('auth/storeAccessToken', res.data.access_token)
                    }
                }
            })
    },

    async updatePayletter({ commit }, payload) {
      await axios.ACCESS.post('/api/payletter/update', {
        auto_payment_id: payload.auto_payment_id,
        pgcode: payload.pgcode,
      })
      .then(res => {
        // console.log('payletter/update', res)
        if (!res.data.result) {
          throw new Error()
        } else {
          commit('setUpdateOnlineURL', res.data.online_url)
          commit('setUpdateMobileURL', res.data.mobile_url)
          commit('setUpdateOrderNo', res.data.order_no)
        }
      })
    },

    async returnUpdatePayletter({ commit }, payload) {
      await axios.ACCESS.post('/api/payletter/update/return', {
        order_no: payload.order_no
      })
      .then(res => {
        // console.log('payletter/update/return', res)
        if (!res.data.result) {
          throw new Error()
        }
      })
    },

    async checkUpdatePayletter({ commit }, payload) {
      await axios.ACCESS.get('api/payletter/update/return/' + payload.order_no)
        .then(res => {
          // console.log('payletter/update/check', res)
          if (!res.data.result) {
            throw new Error()
          } else {
            commit('setUpdateCheckStatus', res.data.status)
            if (res.data.status == 7) {
              store.commit('auth/setAccessToken', res.data.access_token)
              store.commit('auth/storeAccessToken', res.data.access_token)
            }
          }
        })
    },

    async terminatePayletter({ commit }, payload) {
      await axios.ACCESS.post('api/payletter/terminate', {
        auto_payment_id: payload.auto_payment_id,
      })
      .then(res => {
        // console.log('payletter/terminate', res)
        if (!res.data.result) {
          throw new Error()
        } else {
          store.dispatch('user/getMyAutoPayments')
        }
      })
    },

}

export default {
    namespaced: true,
    state: STATE,
    getters: GETTERS,
    mutations: MUTATIONS,
    actions: ACTIONS,
}


// WEBPACK FOOTER //
// ./src/vuex/modules/payment.js